import React, { useState, useEffect } from "react";
import Design from "./Design";
import {
  fetchTopDetails,
  fetchTopWeeklyEvents,
  fetchUserGiftsTop,
  fetchUserGiftsTopHours,
  RoleEvent,
} from "../../services/Weekly_star";
const NewEvents = () => {
  const [roleEventData, setRoleEventData] = useState(null);
  const [topWeeklyData, setTopWeeklyData] = useState(null);
  const [userGiftsTopHours, setUserGiftsTopHours] = useState(null);
  const [userGiftsTop, setUserGiftsTop] = useState(null);
  const [topDetails, setTopDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const data3 = await fetchUserGiftsTopHours();
        const data2 = await fetchTopWeeklyEvents();
        const data4 = await fetchUserGiftsTop();
        const data5 = await fetchTopDetails();
        const data1 = await RoleEvent();
        setRoleEventData(data1.data);
        setTopWeeklyData(data2.data);
        setUserGiftsTopHours(data3.data);
        setUserGiftsTop(data4.data);
        setTopDetails(data5.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <div>
      <Design
        roleEventData={roleEventData}
        topWeeklyData={topWeeklyData}
        userGiftsTopHours={userGiftsTopHours}
        userGiftsTop={userGiftsTop}
        topDetails={topDetails}
      />
    </div>
  );
};

export default NewEvents;
// there is two end points want to replace them
// structure of image
// token
//responsive
